import { FormItem, MenuPresets } from '@framework/form';
import { yup } from '@framework/validation';
import { RichTextAdvancedInput } from '../../../../../inputs/rich-text-advanced/RichTextAdvancedInput';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema';
import { getDefaultAssignableExpressionSchema } from '../../../../expressions/repository/assignable/AssignableExpressionSchema';
import { ValueExpressionType } from '../../../../expressions/repository/value/ValueExpression.type';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { WidgetType } from '../../../Widget';
import { ConfirmationConfigInput } from '../../advanced/confirm/shared/ConfirmationConfigInput';
import { DefaultValueInput } from '../../common/DefaultValueInput';
import { CodeLabelInputForm } from '../common/CodeLabelInputForm';
import { CommonInputWidgetConfigSchema } from '../common/CommonInputConfigComponent';
import { getWidgetProps } from '../common/util/getWidgetProps';
import { IBooleanWidget } from './IBooleanWidget';

export const BooleanWidgetConfigSchema: yup.ObjectSchema<IBooleanWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Boolean).required(),
    text: RichTextAdvancedSchema.optional().label('Testo'),
    // Forzo l'impostazione del valore di default a false per evitare che sia undefined, dando problemi con le regole.
    defaultValue: getDefaultAssignableExpressionSchema({
      ...ValueExpressionType.schema.getDefault(),
      value: false,
    }),
  });

export interface IBooleanConfigComponentProps
  extends IWidgetComponentProps<IBooleanWidget> {}

/**
 * Form di configurazione widget boolean (checkbox/switch).
 * Come il common ma non ha il placeholder.
 */
export function BooleanConfigComponent(props: IBooleanConfigComponentProps) {
  const options = getWidgetProps(props);

  return (
    <div>
      {/* Form Codice + Etichetta */}
      <CodeLabelInputForm widgetOptions={options} />

      <FormItem name="text" label="Testo">
        <RichTextAdvancedInput
          name="text"
          rows={2}
          menus={MenuPresets.InlineWithAlign}
        />
      </FormItem>

      <FormItem name="helpText" label="Testo di aiuto">
        <RichTextAdvancedInput
          name="helpText"
          rows={2}
          menus={MenuPresets.Minimal}
        />
      </FormItem>

      <DefaultValueInput />
      <ConfirmationConfigInput name="confirmation" />
    </div>
  );
}
